// ================================================================================
// logo-slider.js
// ロゴスライダーブロック用のスクリプトファイル
// NOTE: jQuery 使用
// ================================================================================

$(function() {

	function loopTopSlider() {
		let $slider = $('.js-company-logos');
		let $slider_width = $slider.width();
		let $slider_wrap = $('.js-company-logos-slider-wrapper');

		$slider_wrap.find($slider).clone().appendTo($slider_wrap);
	};

	function loopsliderPosition() {
		let $slider_width = $('.js-company-logos:first-of-type').width();
		let $slider_wrap = $('.js-company-logos-slider-wrapper');
		let speed = 30000;

		$slider_wrap.css({ left: '0' });
		$slider_wrap.stop().animate({ left: '-' + ($slider_width) + 'px' }, speed, 'linear');
		setTimeout(function () {
			loopsliderPosition();
		}, speed);
	};
	loopTopSlider();
	loopsliderPosition();


}) ;
